import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import NavMixin from '@/core/mixins/nav.mixin';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';
import EdNavSubmenu from '@/core/components/ed-nav-submenu/ed-nav-submenu.component.vue';
import { INav } from '@/core/interfaces/nav.interface';
import { MENU_TO_REQUEST, NAV_IDS, MAIN_MENU } from '@/core/values/core.values';
import { ROLES } from '@/auth/enums/auth.enum';

@Component({
  name: 'ed-nav-mobile',
  components: {
    EdNavSubmenu
  }
})
export default class EdNavMobile extends Mixins(NavMixin) {

  public navMenuID: string = NAV_IDS.NAV_MOBILE;

  get menuMobile() {
    const menuMobile = this.menu[0];
    menuMobile.submenu = this.menu[0].submenu.map(m => {
      let isAlerted = false;
      if(m.verifyPresentationMode) {
        isAlerted = this.getVerifyPresentationMode(m);
      }
      return {
        ...m,
        isAlerted,
      }
    });
    return menuMobile;
  }

  initMenu() {
    const menuMobile: INav[] = [{
      name: 'menu',
      submenu: MAIN_MENU,
      hasToRequest: MENU_TO_REQUEST.CLASSES_CLASSES_AND_MY_CONTENT,
      notHasToRequestForRoles: [ROLES.EDUAC_AUTHOR],
    }];
    
    const menuSelected = this.getMenu(menuMobile);
    menuSelected[0].submenu[1].verifyPresentationMode = !this.isPublisher;
    this.mainSelected = menuSelected;
    this.menuFormated = [...this.mainSelected];
  }

  created() {
    this.initMenu();
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this.initMenu);
  }

  beforeDestroy() {
    this.$edEventBus.$off(APP_EVENT_BUS.LANGUAGE_CHANGED, this.initMenu);
  }

}